function deconnexionMiddleware() {
    return function wrapDispatch(next) {
        return function handleAction(action) {
            if (
                action.type &&
                action.type.endsWith('HTTP_FAILURE') &&
                action.payload &&
                action.payload.status &&
                action.payload.status === 401
            ) {
                window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
            }
            return next(action);
        };
    };
}
export default deconnexionMiddleware;
